import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {

	getCountries : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.get('admin/countries', {}).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	async getRegions({ commit }, countryCode) {
		try {
			const params = {
				filters: {
					country_code: countryCode,
				},
			};

			const response = await api.get('admin/regions', params);

			return response.data.data;
		} catch (error) {
			console.log('error', error);
			throw error;
		}
	},
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/CountryModule.js